"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * Project/App Name APIs — v1
 * API v1 documentation for the backend services of Project/App Name
 *
 * The version of the OpenAPI document: 1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.instanceOfWaitlistCountDataDto = instanceOfWaitlistCountDataDto;
exports.WaitlistCountDataDtoFromJSON = WaitlistCountDataDtoFromJSON;
exports.WaitlistCountDataDtoFromJSONTyped = WaitlistCountDataDtoFromJSONTyped;
exports.WaitlistCountDataDtoToJSON = WaitlistCountDataDtoToJSON;
exports.WaitlistCountDataDtoToJSONTyped = WaitlistCountDataDtoToJSONTyped;
/**
 * Check if a given object implements the WaitlistCountDataDto interface.
 */
function instanceOfWaitlistCountDataDto(value) {
    if (!('count' in value) || value['count'] === undefined)
        return false;
    return true;
}
function WaitlistCountDataDtoFromJSON(json) {
    return WaitlistCountDataDtoFromJSONTyped(json, false);
}
function WaitlistCountDataDtoFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'count': json['count'],
    };
}
function WaitlistCountDataDtoToJSON(json) {
    return WaitlistCountDataDtoToJSONTyped(json, false);
}
function WaitlistCountDataDtoToJSONTyped(value, ignoreDiscriminator) {
    if (ignoreDiscriminator === void 0) { ignoreDiscriminator = false; }
    if (value == null) {
        return value;
    }
    return {
        'count': value['count'],
    };
}
